import {
  List,
  Datagrid,
  TextField,
  NumberField,
  ChipField,
  ArrayField,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const AgentConfigList = () => (
  <List queryOptions={{ meta: { isMy: true } }}>
    <Datagrid bulkActionButtons={false} rowClick="edit">
      <TextField source="instructions" />
      <NumberField source="temperature" />
      <NumberField source="maxOutputTokens" />
      <ArrayField source="prompts">
        <Datagrid>
          <ChipField source="type" />
          <TextField source="text" />
        </Datagrid>
      </ArrayField>
    </Datagrid>
  </List>
)

export const AgentConfigEdit = () => (
  <Edit queryOptions={{ meta: { isMy: true } }} mutationOptions={{ meta: { isMy: true } }}>
    <SimpleForm>
      <TextInput source="instructions" />
      <NumberInput source="temperature" />
      <NumberInput source="maxOutputTokens" />
      <ArrayInput source="prompts">
        <SimpleFormIterator sx={{ '& .RaSimpleFormIterator-form': { display: 'grid', gridTemplateColumns: '1fr 3fr', gap: 2, alignItems: 'start' } }}>
          <SelectInput
            source="type"
            choices={[
              { id: 'default', name: 'default' },
              { id: 'birthday', name: 'birthday' },
            ]}
          />
          <TextInput source="text" multiline rows={2} />
        </SimpleFormIterator>
      </ArrayInput>
    </SimpleForm>
  </Edit>
)

export const AgentConfigShow = () => (
  <Show queryOptions={{ meta: { isMy: true } }}>
    <SimpleShowLayout>
      <TextField source="instructions" />
      <NumberField source="temperature" />
      <NumberField source="maxOutputTokens" />
      <ArrayField source="prompts">
        <Datagrid>
          <ChipField source="type" />
          <TextField source="text" />
        </Datagrid>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
)
